var uuid = require('uuid4');

var Utils = {
  generateTag(ec, ea, datas = null) {
    const ga_generate = document.querySelector('.ga_generate');
    ga_generate.innerHTML = this.getTag(ec, ea, datas);
  },
  getTag: function(ec, ea, datas, preventLoad = false) {
    const uuid4 = Utils.getUuid();
    //console.info(ec, ea, datas);
    const label = (datas) ? `&el=${datas}` : '';
    const url = `https://www.google-analytics.com/collect?v=1&tid=UA-114380286-2&t=event&ec=${ec}&ea=${ea}${label}&cid=${uuid4}`;
    return `<img border="0" width="0" height="0" src="${url}"/>`;
  },

  formStorage: function( method = 'save', data = {} ){
    const STORAGE_KEY = 'publicis-signature-v2';
    return this.localStorage(method, data, STORAGE_KEY);
  },
  uuidStorage: function( method = 'save', data = {} ){
    const STORAGE_KEY = 'publicis-signature-uuid-v1';
    return this.localStorage(method, data, STORAGE_KEY);
  },
  getUuid: function() {
    const uuid4 = uuid();
    if (!Utils.uuidStorage('fetch')) {
      Utils.uuidStorage('save', uuid4);
      return uuid4;
    }
    return Utils.uuidStorage('fetch');
  },
  localStorage: function( method = 'save', data = {}, storageKey ){
    switch( method ){
        case 'fetch':
          try {
            return JSON.parse(localStorage.getItem(storageKey) || 0)
          } catch (e) {
            return {};
          }
            break;
        case 'save':
          try {
            localStorage.setItem(storageKey, JSON.stringify(data))
          } catch (e) {
            return {};
          }
            break;
    }
  },

  formatPhone: function(phone, indicatif) {
    var numbers = phone.replace(/\D/g, '');
    var formated = '';
    var char = { 0: indicatif + ' (', 1: ')'};
    for (var i = 0; i < numbers.length; i++) {
      formated += (char[i] || (!char[i] && (i%2 === 0) ? ' ' : '')) + numbers[i];
    }
    return formated;
  },

  findGetParameter(parameterName) {
    var result = null,
        tmp = [];
    window.location.search
        .substr(1)
        .split("&")
        .forEach(function (item) {
          tmp = item.split("=");
          if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
        });
    return result;
}
};

export default Utils;


// WEBPACK FOOTER //
// ./src/utils.js